import React, {useState} from "react"
import Logo from "../../images/logo.png"
import useMediaQuery from "../media-query/use-media-query";
import ConversionForm from "../muneem-conversion/conversion-form";

function NavigationBar () {

    const xsDown = useMediaQuery("(max-width: 500px)");
    const mdUp = useMediaQuery("(min-width: 501px)");
    const [open, setOpen] = useState(false);

    return (
        <header
            className={`fixed top-0 z-40 h-20 sm:h-24 flex justify-center w-screen`}
            style={{ background: "#FDFFF5", borderBottom: !xsDown ? "" : "2px solid rgba(80,80,80, 0.9)" }}
        >
            <nav className={"container font-display font-normal h-full w-full flex items-center"} style={{ borderBottom: xsDown ? "" : "2px solid rgba(80,80,80, 0.9)" }}>
                <a href={"#home"} className={"h-6"}>
                    <img alt={"Muneem Logo"} src={Logo} className={"h-6 flex-shrink-0"}/>
                </a>
                <div className={"ml-auto"}/>
                {mdUp &&
                    <div className={"flex items-center space-x-12"}>
                        <a href={"#how-it-works"} className={"hover:underline subtitle-2"}>
                            How it works
                        </a>
                        <a href={"#start-investing"} className={"hover:underline subtitle-2"}>
                            For Investors
                        </a>
                        {/*<a href={"#eff"} className={"hover:underline subtitle-2"}>*/}
                        {/*    For Founders*/}
                        {/*</a>*/}
                        <div>
                            <button onClick={() => { setOpen(true) }} className={"button-primary subtitle-2"} style={{ background: "#caf41f" }}>
                                Join Muneem
                            </button>
                        </div>
                    </div>

                }
                {xsDown &&
                    <div className={"flex items-center space-x-4"}>
                        <div>
                            <button onClick={() => { setOpen(true) }} className={"button-primary subtitle-2"} style={{ background: "#caf41f" }}>
                                Join
                            </button>
                        </div>
                        {/*<FiMenu size={20}/>*/}
                    </div>

                }
            </nav>
            <ConversionForm open={open} onClose={() => {setOpen(false)}}/>
        </header>
    )

}

export default NavigationBar;